import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslate } from "../../context/TranslationContext";
import { useGetPressQuery } from "../../redux/Apis/Press";
import Button from "../button";
import PressCard from "../cards/PressCard";

const PressSection = () => {
  const { t } = useTranslate("pressbanner");
  const lang = useSelector((state) => state.language.lang);
  const {
    data: pressData,
    isLoading: isPressLoading,
    refetch: refetchPress,
  } = useGetPressQuery(
    { page: 1, rowsPerPage: 3, active: true, lang },
    { refetchOnMountOrArgChange: false }
  );
  const press = pressData?.data || [];

  useEffect(() => {
    refetchPress();
  }, []);

  return (
    <section className="latest-press py-sm-5 py-4">
      <div className="container">
        <div className="text-center">
          <h2 className="gallery-title text-uppercase text-white mb-3">
            {t("title")}
          </h2>
          <p className="mb-4 p-lg l-grey-text">{t("subtitle")}</p>
        </div>

        <div className="row justify-content-center g-4">
          {isPressLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner style={{ color: "var(--primaryColor)" }} />
            </div>
          ) : press.length > 0 ? (
            press.slice(0, 3).map((item) => (
              <div
                key={item._id}
                className="col-md-4 col-sm-6 d-flex justify-content-center"
              >
                <PressCard data={item} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center mt-5">
              <h6 className="text-white">{t("nofound")}</h6>
            </div>
          )}
        </div>

        {press.length > 0 && (
          <div className="text-center mt-md-5 mt-4">
            <Button text={t("morebtn")} to="/press" />
          </div>
        )}
      </div>
    </section>
  );
};

export default PressSection;
